import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilterButtonGroup from '../../components/Filter/FilterButtonGroup';
import { configFilter } from './SecureMessagesConfig';
import { toggleMessageThreadsFilter, threadMessagesRequested }
from '../../redux/modules/secure-message/secure-message-middleware';
import { secureMessageThreadClear } from '../../redux/modules/secure-message/actions/creators';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

class SecureMessagesFilter extends Component {
  handleClickEvent = (filterValue) => {
    if (!filterValue || filterValue.length === 0) {
      return;
    }
    this.props.dispatch(MsgBarActions.dismissMessage());
    const { dispatch, patientId, language, timeZone, timeZoneOffset, selectedThreadIndex, selectedArchivedThreadIndex }
    = this.props;

    dispatch(toggleMessageThreadsFilter(filterValue));

    const threadId = filterValue === 'Current' ? selectedThreadIndex : selectedArchivedThreadIndex;
    if (threadId !== null && threadId !== undefined) {
      dispatch(threadMessagesRequested(
        patientId, threadId, language, timeZone, timeZoneOffset));
    } else {
      dispatch(secureMessageThreadClear());
    }
  }

  render() {
    return (
      <div className="form-group col-md-3 col-sm-4 col-xs-6">
        <FilterButtonGroup
          handleClickEvent={ this.handleClickEvent }
          { ...configFilter(this.props.filter) }
        />
      </div>
    );
  }
}

SecureMessagesFilter.propTypes = {
  dispatch: PropTypes.func,
  filter: PropTypes.string,
  patientId: PropTypes.number.isRequired,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  selectedThreadIndex: PropTypes.number,
  selectedArchivedThreadIndex: PropTypes.number,
};

const mapStateToProps = (state) => ({
  filter: state.secureMessage.filter,
  patientId: state.profile.patient.patientId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
});

export default connect(mapStateToProps)(SecureMessagesFilter);